import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Hotline } from '@etop/models';
import { HotlineStore, StateHotline } from '@etop/state/shop/hotline/hotline.store';

@Injectable({
  providedIn: 'root'
})
export class HotlineQuery extends QueryEntity<StateHotline, Hotline> {
  constructor(protected store: HotlineStore) {
    super(store);
  }

  get filter() {
    return this.getValue().ui.filter;
  }

  get paging() {
    return this.getValue().ui.paging;
  }

  get currentUi() {
    return this.getValue().ui;
  }

  getIsFreeCharge(hotline_id: string) {
    const hotlines = this.getAll();
    return hotlines.find(hotline => hotline.id == hotline_id)?.is_free_charge;
  }
}
